const options = {
  5: "bg-fuchsia-500/5",
  10: "bg-fuchsia-500/10",
  25: "bg-fuchsia-500/25",
  50: "bg-fuchsia-500/50",
  75: "bg-fuchsia-500/75",
  90: "bg-fuchsia-500/90",
  100: "bg-fuchsia-500",
};

const from = {
  5: "from-fuchsia-500/5",
  10: "from-fuchsia-500/10",
  25: "from-fuchsia-500/25",
  50: "from-fuchsia-500/50",
  75: "from-fuchsia-500/75",
  90: "from-fuchsia-500/90",
  100: "from-fuchsia-500",
};

export default function getBackgroundFuchsia500(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
